import { render, staticRenderFns } from "./SettingsPanelVideoDialog.vue?vue&type=template&id=8e6f0a5a"
import script from "./SettingsPanelVideoDialog.vue?vue&type=script&lang=js"
export * from "./SettingsPanelVideoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports